import { render } from "./TheProfessionalDocument.vue?vue&type=template&id=033a8a7a&scoped=true&ts=true"
import script from "./TheProfessionalDocument.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalDocument.vue?vue&type=script&lang=ts"

import "./TheProfessionalDocument.vue?vue&type=style&index=0&id=033a8a7a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033a8a7a"]])

export default __exports__